import { Breadcrumbs, Header } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { BreadcrumpItem } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { FC, ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

type Props = {
  title: string
  breadCrumbs: BreadcrumpItem[]
  rightRenderOption?: ReactNode
}

export const ReleaseDetailsHeader: FC<Props> = observer(props => {
  const { title, breadCrumbs, rightRenderOption } = props

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Breadcrumbs items={breadCrumbs} />
      <Header title={title} rightRenderOption={rightRenderOption} />
    </>
  )
})
